/**
 * Round Expander Validation Schemas
 * Zod schemas for round expansion configuration
 */
import { z } from "zod";
/**
 * Schema for round expansion configuration
 */
export const RoundExpansionConfigSchema = z.object({
    // Required
    brand: z.string().min(1, "Brand is required"),
    model: z.string().min(1, "Model is required"),
    // Mileage range (km)
    mileage_from: z.number().min(0),
    mileage_to: z.number().min(0),
    mileage_steps: z.number().min(1),
    // Power range (kW)
    power_from: z.number().min(0),
    power_to: z.number().min(0),
    power_steps: z.number().min(1),
    // Year range
    year_from: z.number().min(1900),
    year_to: z.number().max(new Date().getFullYear() + 1),
    // Optional filters
    fuel: z.array(z.string()).optional(),
    transmission: z.array(z.string()).optional(),
    vehicle_type: z.array(z.string()).optional(),
    variant: z.string().optional(),
});
//# sourceMappingURL=roundExpander.schema.js.map